import { render } from "./BaseContainer.vue?vue&type=template&id=6df1e54c"
import script from "./BaseContainer.vue?vue&type=script&lang=js"
export * from "./BaseContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__